const vars = {
    LAMBDA_API_BASE: 'https://11m015rpgi.execute-api.us-east-1.amazonaws.com/prod/generateAttributes?genes=',
    ASSETS_BASE: 'https://s3.amazonaws.com/ethertulips-assets/',
    DUEL_API_BASE: 'https://duel.ethertulips.com:4000/',
    // DUEL_API_BASE: 'http://localhost:4000/',
};

export default vars;
